import gameService from '../services/game.service';

export const ALL = 'all';
export const SLOTS = 'slots';
export const VIDEO_GAMES = 'video-games';
export const VIRTUAL_SPORTS = 'virtual-sports';
export const VIRTUALS = 'virtuals';
export const SPORT = 'sport';
export const POKER = 'poker';
export const JACKPOT = 'jackpot';
export const SAFARICOM = 'safaricom';
export const RACES = 'races';
export const LIVE_CASINO = 'live-casino';
export const COVID = 'covid';
export const SOFT_GAMINGS = 'softgamings';
export const SKILL_GAMES = 'skillgames';
export const MULTIPLAYER = 'multiplayer';
export const XGAMES = 'xgames';

export const GAMES_IMAGE_OVERRIDE = [
    'fortuna',
    'fortuna-black',
    'spin-to-win-suit',
    'spin-to-win-violet',
    'aviator',
    'happy-hour-friut-slot',
    'safari-big-7',
    'mega-fruits',
    'happy-fruits',
    'jet',
    'pilotx',
    'pilot',
    'rocket'
];

export const RACES_GAMES = [
    'safari-big-7',
    'fortuna',
    'fortuna-black',
    'keno-live',
    'keno-neon',
    'keno-night',
    'xkeno',
    'penalty',
    'four-aces',
    'crown-and-anchor',
    'etraces',
    'rock-vs-paper-vikings-mode',
    'courier-sweeper',
    'magic-wheel',
    'mine-field',
    'football-manager',
    'high-striker',
    '37',
    'jacks-or-better',
    'wheel-of-time',
    'penalty-shoot-out',
    'thimbles',
    'lucky-crumbling',
    'aviatrix',
    'globe-roulette',
    '248',
    'spin-to-win',
    'bomb-squad',
    'heads-and-tails',
    'christmas-party',
    'royal-crown-roulette-european',
    'spin-to-win-suit',
    'spin-to-win-violet',
    'aviator',
    'happy-hour-friut-slot',
    'jet',
    'mega-fruits',
    'happy-fruits',
    'pilotx',
    'pilot'
];

const categorySettings = {
    [ALL]: {
        color: 'has-text-warning',
        altColor: 'has-text-warning-dark',
        icon: 'far fa-gem'
    },
    [SLOTS]: {
        color: 'has-text-warning',
        altColor: 'has-text-warning-dark',
        icon: 'far fa-gem'
    },
    [VIDEO_GAMES]: {
        color: 'has-text-danger',
        altColor: 'has-text-danger',
        icon: 'fas fa-dice'
    },
    [VIRTUAL_SPORTS]: {
        color: 'has-text-link',
        altColor: 'has-text-link',
        icon: 'fas fa-video'
    },
    [SPORT]: {
        color: 'has-text-ice',
        altColor: 'has-text-ice-dark',
        icon: 'fas fa-futbol',
        textColor: 'has-text-ice',
        altTextColor: 'has-text-ice-dark'
    },
    [POKER]: {
        color: 'has-text-white',
        altColor: 'has-text-grey-dark',
        icon: 'icon-spades-light',
        altIcon: 'icon-spades-dark'
    },
    [JACKPOT]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [SAFARICOM]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [RACES]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [LIVE_CASINO]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [COVID]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [SOFT_GAMINGS]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [SKILL_GAMES]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [MULTIPLAYER]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    },
    [XGAMES]: {
        color: 'has-text-warning',
        icon: 'fas fa-crown',
        textColor: 'has-text-warning',
        altTextColor: 'has-text-warning-dark'
    }
};

const handlers = {
    games: {
        set: 'games_set'
    }
};

const initVuexState = function(state) {
    state.games = {
        popular: [],
        new: [],
        jackpotGames: [],
        categories: [],
        lists: {},
        allGames: []
    };
};

const initGetters = function(getters) {
    getters.games = state => state.games;
    getters.gamesById = state => (provider, id) => {
        return state.games.allGames.find(g => g.provider === provider && g.gameId === id);
    };
    getters.gamesByFilters = state => filters => {
        const games = [];
        for (let i = 0; i < filters.length; i++) {
            const filter = filters[i];
            let filtredGames = [];
            const filteredGame = state.games.categories
                .filter(c => !filter.category || c.name === filter.category)
                .reduce((a, c) => {
                    const items = c.games.filter(g => !filter.gameId || g.gameId === filter.gameId);
                    a.push(...items);
                    return a;
                }, []);
            games.push(...filteredGame);
        }
        const result = [];
        const dict = {};
        for (let i = 0; i < games.length; i++) {
            const game = games[i];
            if (dict[game.id]) continue;
            dict[game.id] = true;
            result.push(game);
        }
        return result;
    };
    getters.gamesByList = state => listName => {
        return state.games.lists[listName];
    };
};

const initActions = function(actions) {
    actions[handlers.games.set] = ({ commit }, games) => commit(handlers.games.set, games);
};

const initMutations = function(mutations) {
    mutations[handlers.games.set] = (state, games) => (state.games = games);
};

let gamesPromise = null;

const initAppState = function(appState, store) {
    appState.games = {
        categorySettings: categorySettings,
        get: () => store.getters.games,
        getById: (provider, id) => store.getters.gamesById(provider, id),
        getByFilters: filters => store.getters.gamesByFilters(filters),
        getByList: listName => store.getters.gamesByList(listName),
        ensure: () => {
            if (!gamesPromise) {
                gamesPromise = gameService.getAll();
                gamesPromise.then(games => {
                    store.dispatch(handlers.games.set, games);
                });
            }
            return gamesPromise;
        },
        reload: async () => {
            const promise = gameService.getAll();

            promise.then(games => {
                gamesPromise = promise;
                store.dispatch(handlers.games.set, games);
            });
            return promise;
        }
    };
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/games.js